import { defineStore } from "pinia";
import BreedingStudService from "../services/BreedingStudService";
import { IBreedingStud, IBreedingStudPDTO } from "../models/breedingStud";

//Store Pinia BreedStud
export const useBreedingStud = defineStore("breedingsStud", {
  state: () => ({
    datas: [] as Array<IBreedingStud>,
    current: {} as IBreedingStud
  }),

  actions: {

    /**
     * Récupération et stockage des élévages
     * 
     * @param page Numéro de la page souhaité
     * @param pageSize Nombre de résultats par page
     * @param indicativeMarking Numéro de marquage recherché
     * 
     * @returns Liste des élévages correspondants au filtre
     */
    async loadBreedingStud( page: number, pageSize: number, indicativeMarking: string = "") {
      
      let result = await BreedingStudService.getBreedingStud(page, pageSize, indicativeMarking);

      this.datas = [];

      if (!result.err) {
        this.datas = result.data;
      } else {
        this.datas = [];
      }

      return result;
    },

    /**
     * Récupère et met à jour l'élavage courant
     * 
     * @param id ID de l'évage à modifier
     * 
     * @returns Elevage modifié
     */
    async setCurrentBreeding(id: number): Promise<IBreedingStud>{
      
      const result = await BreedingStudService.getBreedingStudById(id);
      if (result) {
        this.current = result.data[0];
      }

      return this.current;
    },

    /**
     * Création et stockage d'un nouvel élevage
     * 
     * @param newBreeding Elevage à ajouter
     * 
     * @returns
     */
    async createBreeding(breedingStud: IBreedingStud) {
      let bdto = this.breedingStudToDTO(breedingStud);
      const result = await BreedingStudService.createBreedingStud(bdto);
      return result;
    },

    /**
     * Mise à jour de l'évage courant et mise à jour du store
     * 
     * @param breedingStud Elevage à modifier
     * 
     * @returns Elevage modifié
     */
    async updateBreedingInList(data: IBreedingStud) {
      let bdto = this.breedingStudToDTO(data);
      const result = await BreedingStudService.updateBreedingStud(bdto);

      if (!result.err) { //Aucune erreur API
        const index = this.datas.findIndex(
          ({ id }) => id === data.id,
        );

        if (index >= 0) {
          this.datas.splice(index, 1, result.data);
        } else {
          this.datas.splice( this.datas.length , 0 , result.data );
        }
      }

      return result;
    },

    /**
     * Mise à jour de la liste des élevages (dans le store)
     * @param breedingsStud 
     */
    storeBreedings(breedingsStud: IBreedingStud[]) {
      this.datas = breedingsStud;
    },

    async editKaryotypeStatus(breedingStudId: number, isActive: boolean) {
      await BreedingStudService.editBreedingStudActiveStatus(breedingStudId, isActive);
    },

    breedingStudToDTO(breedingStud: IBreedingStud) : IBreedingStudPDTO {
      let bdto = {} as IBreedingStudPDTO;
      Object.assign(bdto, breedingStud);
      bdto.speciesId = breedingStud.species.id;
      return bdto;
    },
    DTOToBreedingStud(bdto: IBreedingStudPDTO) : IBreedingStud {
      let breedingStud = {} as IBreedingStud;
      Object.assign(breedingStud, bdto);
      breedingStud.species = { id: bdto.speciesId, value: "" ,actives: true, order: 0};
      return breedingStud;
    }
  },
});
